import React, { useState } from 'react';
import {
    Menu,
    MenuItem,
    IconButton,
    Box,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const ThreadMenu = ({ onDelete, onRename, threadId }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation(); // Prevent triggering the thread selection
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = (e) => {
        e.stopPropagation(); // Prevent triggering the thread selection
        onDelete(threadId);
        handleClose();
    };

    const handleRename = (e) => {
        e.stopPropagation(); // Prevent triggering the thread selection
        onRename(threadId);
        handleClose();
    };

    return (
        <Box onClick={(e) => e.stopPropagation()}>
            <IconButton
                edge="end"
                aria-label="menu"
                onClick={handleClick}
                sx={{ 
                    color: 'text.primary',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <MoreHorizIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        width: 150,
                        mt: 1.5,
                        padding: 1,
                        borderRadius: 2,
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                onClick={(e) => e.stopPropagation()} // Prevent triggering the thread selection
            >
                <MenuItem onClick={handleRename}>
                    Rename
                </MenuItem>
                <MenuItem onClick={handleDelete}>
                    Delete
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default ThreadMenu; 